import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import dataNitivIcon from "../../../assets/images/icons/DataNitiv.svg";

/**
 * DataNitivSyncIcon
 *
 * Small inline indicator placed next to a field label to show that the
 * field's value is synced from / controlled by DataNitiv (DN).
 * Renders the locally hosted DataNitiv mark inside a hover tooltip.
 *
 * Designed to sit inline next to label text (e.g. inside a <Typography>
 * or the shared <TextLabel/>), so it uses vertical-align: middle and a
 * trailing margin.
 */
export default function DataNitivSyncIcon({
  title = "DataNitiv-synced data",
  size = 16,
  placement = "top",
}) {
  return (
    <Tooltip title={title} arrow placement={placement}>
      <img
        src={dataNitivIcon}
        alt="DataNitiv-synced data"
        height={size}
        style={{
          width: "auto",
          verticalAlign: "middle",
          marginRight: 4,
          cursor: "default",
          position: "relative",
          top: "-1px",
        }}
      />
    </Tooltip>
  );
}

DataNitivSyncIcon.propTypes = {
  title: PropTypes.string,
  size: PropTypes.number,
  placement: PropTypes.string,
};
